<template>
  <div>
    <form-header />
    <box class="p-5">
      <b-form @submit.prevent="submit()">
        <b-form-group>
          <slot name="label">
            <div>
              <label for="email" class="col-form-label pt-0">
                <span>
                  {{ $t('email') }}
                </span>
                <span v-if="errors.email" class="text-danger">
                  - {{ errors.email }}
                </span>
              </label>
            </div>
          </slot>
          <b-form-input
            v-model="form.email"
            size="lg"
            id="email"
            type="email"
            required
          />
        </b-form-group>
        <b-button
          @click="submit()"
          :disabled="isDisabled"
          style="width: 100%;"
          variant="primary"
          class="mt-4"
          type="button"
        >
          {{ $t('recoverPassword') }}
        </b-button>
      </b-form>
    </box>
  </div>
</template>

<script>
import FormHeader from './FormHeader.vue';

export default {
  components: {
    FormHeader
  },

  data() {
    return {
      errors: {},
      form: {
        email: null
      }
    };
  },

  computed: {
    isDisabled() {
      return this.form.email && this.form.email.length < 1;
    }
  },

  methods: {
    submit() {
      this.errors = {};

      this.$api.auth.post('/auth/password/reset', this.form).then(
        () => {
          this.$notify('alert', {
            text: this.$t('emailSuccessfullySent'),
            variant: 'success',
            time: 5000
          });
        },
        e => {
          this.errors = {};
          if (e.response.data.error.errors) {
            this.errors = e.response.data.error
              ? this.$parseAuthErrors(e.response.data.error.errors)
              : {};
          } else {
            e.response.data.error.message &&
              this.$notify('alert', {
                text: e.response.data.error.message,
                variant: 'danger',
                time: 5000
              });
          }
        }
      );
    }
  }
};
</script>
